module.exports = __webpack_public_path__ + "media/images/favicon/favicon-16x16-fd8b02359abbe7af6edfb9766a3a0cdf.png";